import { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
} from '@mui/material'

function ArchiveDialog({ open, onClose, onConfirm, entityName }) {
  const [reason, setReason] = useState('')
  const [error, setError] = useState('')

  const handleClose = () => {
    setReason('')
    setError('')
    onClose()
  }

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError('Archive reason is required')
      return
    }

    onConfirm(reason.trim())
    setReason('')
    setError('')
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Archive {entityName}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Please provide a reason for archiving this {entityName.toLowerCase()}. This information will be displayed in the inactive records.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={4}
          label="Archive Reason"
          value={reason}
          onChange={(e) => {
            setReason(e.target.value)
            setError('')
          }}
          error={!!error}
          helperText={error || 'This field is required'}
          required
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Archive
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ArchiveDialog

